<template>
  <nav>
    <v-toolbar app  class="indigo darken-3" dark>
      <v-toolbar-side-icon  class="grey--text" @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="mr-4 display-1 grey--text text--lighten-2">
          <router-link class="home" tag="span" :to="{name:'home'}">
            <span >WW2</span><span class="font-weight-thin">Database</span>            
          </router-link>
       </v-toolbar-title>

       <v-toolbar-items>   
           <v-btn
             flat dark :to="{name:'people'}">
             People
           </v-btn>  
            <v-btn
               flat dark :to="{name:'units'}">
               Units
           </v-btn> 
            <v-btn
               flat dark :to="{name:'ranks'}">
               Ranks
           </v-btn>        
            <v-btn
               flat dark :to="{name:'cemeteries'}">
               Cemeteries
           </v-btn>                 
           <v-btn
               flat dark :to="{name:'codes'}">
               Codes
           </v-btn> 
           <v-btn
               flat dark :to="{name:'places'}">
               Places
           </v-btn>     
           <v-btn v-if ='$store.state.isEditor'
               flat dark :to="{name:'editorReports'}">
               Editor Reports
           </v-btn>             
       </v-toolbar-items>

       <v-spacer></v-spacer>
      
       <v-toolbar-items>    

            <v-btn v-if ='!$store.state.loggedIn'
               flat dark :to="{name:'login'}">
               Login
           </v-btn>
           <!-- v-btn v-if ='!$store.state.loggedIn'  TEMP TODO
               flat dark :to="{name:'register'}">
               Sign Up
           </v-btn -->
           <v-btn v-if ='$store.state.loggedIn'
               flat dark  @click="logout()">
               <div style='margin-top: -0.5em;'>Logout</div>
               <div style='font-size: 75%;text-transform: none;margin-top: 2.5em;margin-left: -6.2em;'> {{$store.state.user.email}}</div>
               <v-icon right>exit_to_app</v-icon>
           </v-btn>           
        
       </v-toolbar-items>

    </v-toolbar>

    <v-navigation-drawer v-model="drawer" class="indigo darken-4" app>
      <v-list>
        <v-list-tile v-for="link in links" :key="link.text" router :to="link.route">
          <v-list-tile-action>
            <v-icon class='white--text'>{{link.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">{{link.text}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

    </v-navigation-drawer>

  </nav>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      drawer: false,
      links: [
        {icon: 'favorite', text: 'Favourites', route: '/'},
        {icon: 'history', text: 'Change history', route: '/'},
        {icon: 'storage', text: 'Recently viewed', route: '/'}

      ]
    }
  },

  methods: {
    async logout () {

      try {
        const response = await AuthenticationService.logout() ;
        console.log("logout response: " + JSON.stringify(response)) ;
      }
      catch (error) {
        console.log("logout failed:" + error) ;
      }
      finally {
        this.$store.dispatch('setUserAndToken', null, null) ;
      }

      // redirect to homepage
      this.$router.push({
        name: 'home'
      }) ;
    }
  }
}
</script>

<style scoped>
.home { cursor: pointer}
.home:hover { background:#6666bb}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue